const FOCUSABLE_SELECTOR = [
	'a[href]',
	'button:not([disabled])',
	'input:not([disabled]):not([type="hidden"])',
	'select:not([disabled])',
	'textarea:not([disabled])',
	'[contenteditable="true"]',
	'[tabindex]',
].join(', ');

// Browsers disagree on `tabIndex` for a contenteditable without the attribute, yet all make it a stop.
const isInTabOrder = (element: HTMLElement): boolean =>
	element.hasAttribute('tabindex') || element.getAttribute('contenteditable') !== 'true' ? element.tabIndex >= 0 : true;

/** Tab stops inside `root`, in document (Tab) order. */
export const listTabStops = (root: ParentNode): HTMLElement[] =>
	Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)).filter(
		element => isInTabOrder(element) && !element.closest('[hidden], [aria-hidden="true"]')
	);

/** Moves focus to the first tab stop inside `root`. Returns false when there is none. */
export const focusFirstTabStop = (root: ParentNode | null): boolean => {
	const first = root ? listTabStops(root)[0] : undefined;
	if (!first) return false;
	first.focus();
	return true;
};

/** Moves focus to the first tab stop in `root` that follows `anchor` and sits outside it. */
export const focusFirstTabStopAfter = (root: ParentNode | null, anchor: Element | null): boolean => {
	if (!root || !anchor) return false;
	// Exactly FOLLOWING: a descendant of `anchor` also carries CONTAINED_BY, so it never matches.
	const next = listTabStops(root).find(
		element => anchor.compareDocumentPosition(element) === Node.DOCUMENT_POSITION_FOLLOWING
	);
	if (!next) return false;
	next.focus();
	return true;
};
